<div class="app-vacation-calendar" style="max-height: 600px; overflow-y: auto">
    <div fxLayout="row" class="selectMonth">
        <div fxLayout="column" class="selector">
            <button mat-flat-button (click)="changeMes(-1)" color="primary">Anterior</button>
        </div>
        <div fxLayout="column" class="selector-text align-items-center">
            <span class="texto-mes"> {{ meses[mes] }}, {{ agno }}</span>
        </div>
        <div fxLayout="column" class="selector">
            <button mat-flat-button (click)="changeMes(1)" color="primary">Siguiente</button>
        </div>
    </div>
    <div fxLayout="row">
        <table class="table align-middle mb-0 bg-white">
            <thead>
                <tr class="headerCard">
                    <th class="person"></th>
                    @for (dia of dias(); track $index) {
                        <th class="day secundary-text">
                            {{ dia }}
                            <p class="diaSemana">{{ getDiaSemana(dia) }}</p>
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (person of persons(); track $index) {
                    <tr>
                        <td class="person-container">
                            <div fxLayout="row" class="fila">
                                <div fxLayout="column" class="imagen" fxLayoutAlign="center center">
                                    <img
                                        style="height: auto !important"
                                        [src]="getImageUser(person.username)"
                                        alt="Avatar"
                                    />
                                </div>

                                @if (person.tooltipText) {
                                    <div
                                        fxLayout="column"
                                        style="width: 80%; justify-content: center"
                                        [matTooltip]="person.tooltipText"
                                        matTooltipClass="tooltip-multiline"
                                    >
                                        <b class="person-name">{{ person.name }}</b>
                                        @if (person.dias_restantes || person.dias_restantes == 0) {
                                            <b class="person-name" style="margin-top: 5px"
                                                >* Saldo: {{ person.dias_restantes }} dias
                                            </b>
                                            <b class="person-name">* Disfrutados: {{ person.dias_usados }} dias</b>
                                        }
                                    </div>
                                } @else {
                                    <div fxLayout="column" style="width: 80%; justify-content: center">
                                        <b class="person-name">{{ person.name }}</b>
                                        @if (person.dias_restantes || person.dias_restantes == 0) {
                                            <b class="person-name" style="margin-top: 5px"
                                                >Saldo: {{ person.dias_restantes }} dias</b
                                            >
                                            <b class="person-name">Disfrutados: {{ person.dias_usados }} dias</b>
                                        }
                                    </div>
                                }
                            </div>
                        </td>
                        @for (m of person.values; track $index) {
                            <td>
                                <div fxLayout="row" style="color: transparent">-</div>
                                <div
                                    fxLayout="row"
                                    class="burbuja"
                                    [ngClass]="[
                                        m == -1 ? 'color-1' : '',
                                        m == 1 ? 'color1' : '',
                                        m == 2 ? 'color2' : '',
                                        m == 3 ? 'color3' : '',
                                        m == 4 ? 'color4' : '',
                                        m == 5 ? 'color5' : '',
                                        m == 6 ? 'color6' : '',
                                        m == 7 ? 'color7' : '',
                                        m == 8 ? 'color8' : '',
                                        m == 9 ? 'color9' : '',
                                        m == 10 ? 'color10' : '',
                                        m == 11 ? 'color11' : '',
                                        m == 12 ? 'color12' : '',
                                        m == 15 ? 'color15' : ''
                                    ]"
                                    [matTooltip]="getTooltip(m)"
                                >
                                    -
                                </div>
                                <div fxLayout="row" style="height: 33%; color: transparent">-</div>
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
